@if (!leftSidebarVisible()) {
<button class="sidebar-toggle" (click)="leftSidebarService.toggleSidebar()"></button>
}
<div class="left-menu">
    <ev-sidebar [visible]="leftSidebarVisible()" [sidebarPosition]="'left'" [topPosition]="48">
        <searchbar></searchbar>
        <ng-content select="[slot='left-menu']" id="left-menu-content"></ng-content>
    </ev-sidebar>
</div>
<div class="right-menu-buttons" [ngClass]="{ 'sidebar-open': rightSidebarVisible() }">
    <ng-content select="[slot='right-menu-buttons']"></ng-content>
</div>
<div class="right-menu">
    <ev-sidebar [visible]="rightSidebarVisible()" [topPosition]="rightSidebarTopPosition">
        <ng-content select="[slot='right-menu']"></ng-content>
    </ev-sidebar>
</div>
